import { createSlice } from "@reduxjs/toolkit";

//initial state
const initialState = {
    tags: [],
    searchText: "",
    author: "",
    currentPage: 1,
    videosPerPage: 8,
    activeId: 1,
};

// filter slice
const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        selectTag: (state, action) => {
            state.currentPage = 1;
            state.activeId = 1;
            state.searchText = "";
            state.author = "";
            state.tags.push(action.payload);
        },

        removeTag: (state, action) => {
            const indexToRemove = state.tags.indexOf(action.payload);

            if (indexToRemove !== -1) {
                state.tags.splice(indexToRemove, 1);
                state.currentPage = 1;
                state.activeId = 1;
            }
        },

        searched: (state, action) => {
            state.currentPage = 1;
            state.activeId = 1;
            state.tags = [];
            state.author = "";
            state.searchText = action.payload;
        },

        selectedAuthor: (state, action) => {
            state.currentPage = 1;
            state.activeId = 1;
            state.tags = [];
            state.searchText = "";
            state.author = action.payload;
        },

        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },

        setActiveId: (state, action) => {
            state.activeId = action.payload;
        },

        clearFilters: (state) => {
            state.currentPage = 1;
            state.activeId = 1;
            state.tags = [];
            state.searchText = "";
            state.author = "";
        },
    },
});

export default filterSlice.reducer;
export const {
    selectTag,
    removeTag,
    searched,
    selectedAuthor,
    clearFilters,
    setCurrentPage,
    setActiveId,
} = filterSlice.actions;
